import dayjs from 'dayjs'
import isBetweenDayjs from 'dayjs/plugin/isBetween'
export default {
    isBetween: (from: string, to: string) => {
        dayjs.extend(isBetweenDayjs)
        return dayjs().isBetween(dayjs(from), dayjs(to))
    }
}